Array.prototype.append = function(el) {
  if (this.push != null) {
    this.push(el);
  }
  return this;
};

document.addEventListener('DOMContentLoaded', function() {});
